export default {
  headers: [],
  results: []
}